import { render, staticRenderFns } from "./rebate.vue?vue&type=template&id=3a68a408&scoped=true&"
import script from "./rebate.vue?vue&type=script&lang=js&"
export * from "./rebate.vue?vue&type=script&lang=js&"
import style0 from "./rebate.vue?vue&type=style&index=0&id=3a68a408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a68a408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a68a408')) {
      api.createRecord('3a68a408', component.options)
    } else {
      api.reload('3a68a408', component.options)
    }
    module.hot.accept("./rebate.vue?vue&type=template&id=3a68a408&scoped=true&", function () {
      api.rerender('3a68a408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/rebate.vue"
export default component.exports